import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { Response } from "../models/response";
import { Usuario } from "../models/usuario";
import { StorageService } from "./storage.service";
import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})

export class WebService {

    url = environment.URL_WEBSERVICES;

    constructor(
        private http: HttpClient,
        private storageService: StorageService
    ) {

    }

    peticionPost(url: string, json: unknown, isToken: boolean): Observable<Response> {

        const token = this.obtenerToken(isToken);
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        });


        return this.http.post<Response>(url, json, { headers }).pipe(
            catchError((error) => {
                if (error.status == undefined) {
                    return throwError(() => error)
                } else {
                    const mensaje = this.mensajesErrores(error.status, error?.error?.message ?? error?.message)
                    const respuesta: Response = { isSuccess: false, message: mensaje }
                    return throwError(() => respuesta)
                }
            })
        );
    }

    peticionGet(url: string, isToken: boolean): Observable<Response> {

        const token = this.obtenerToken(isToken);

        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        });

        return this.http.get<Response>(url, { headers }).pipe(
            catchError((error) => {
                if (error.status == undefined) {
                    return throwError(() => error)
                } else {
                    const mensaje = this.mensajesErrores(error.status, error?.error?.message ?? error?.message)
                    const respuesta: Response = { isSuccess: false, message: mensaje }
                    return throwError(() => respuesta)
                }
            })
        );
    }

    peticionPostFormData(url: string, formData: FormData, isToken: boolean): Observable<Response> {

        const token = this.obtenerToken(isToken);
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`
        });


        return this.http.post<Response>(url, formData, { headers }).pipe(
            catchError((error) => {
                if (error.status == undefined) {
                    return throwError(() => error)
                } else {
                    const mensaje = this.mensajesErrores(error.status, error?.error?.message ?? error?.message)
                    const respuesta: Response = { isSuccess: false, message: mensaje }
                    return throwError(() => respuesta)
                }
            })
        );
    }

    peticionPostArchivos(url: string, json: unknown, isToken: boolean): Observable<Blob> {

        const token = this.obtenerToken(isToken);

        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        });

        return this.http.post(url, JSON.stringify(json), {
            headers,
            responseType: 'blob' as const
        }).pipe(
            catchError((error) => {
                if (error.status == undefined) {
                    return throwError(() => error)
                } else {
                    const mensaje = this.mensajesErrores(error.status, error?.error?.message ?? error?.message)
                    const respuesta: Response = { isSuccess: false, message: mensaje }
                    return throwError(() => respuesta)
                }
            })
        );
    }



    private mensajesErrores(code: number, error: any): string {

        switch (code) {
            case 404:
                return 'Webservices no encontrada: endpoint not found';
            case 500:
                return `Error en el servidor: ${error}`;
            case 503:
                return `Error en el servidor: ${error}`;
            case 400:
                return error;
            case 401: // token invalido o caducado
                return `No tienes autorización: ${error}`;
            case 403: //no tienes permiso de roles
                return `No tienes permisos para realizar esta acción.`;

            case 0:
                return 'Servicio no disponible';
            default:
                return `Error desconocido, comunícate con TI: ${error}`;
        }
    }

    private obtenerToken(isToken: boolean): string {
        if (!isToken) {
            return '';
        }

        const usuario = this.storageService.storageGet<Usuario>("usuario");
        return usuario?.token ?? '';
    }

}
